// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"IconDropzone__dropzone___2ojv9","error":"IconDropzone__error___2mUYQ","disabled":"IconDropzone__disabled___2Uy5q","dropzone-msg":"IconDropzone__dropzone-msg___r7DXn _typography__smallInfo___e4AsH _typography__headers___eO5yD","icon":"IconDropzone__icon___1bk0n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropzone/IconDropzone.scss
// module id = 516
// module chunks = 0